import { render, staticRenderFns } from "./insUnit.vue?vue&type=template&id=360ab360&"
import script from "./insUnit.vue?vue&type=script&lang=js&"
export * from "./insUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports